export enum TEMPLATE_TYPES {
  one_column = 'one_column',
  two_column = 'two_columns_center',
  two_columns_left = 'two_columns_left',
  two_columns_right = 'two_columns_right',
  latest_template = 'latest_template'
}
